import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import { ThemeProvider } from 'styled-components';
import { saasModernTheme } from 'common/src/theme/saasModern';
import { DrawerProvider } from 'common/src/contexts/DrawerContext';
import { ResetCSS } from 'common/src/assets/css/style';
import Sticky from 'react-stickynode';
import Navbar from '../containers/SaasModern/Navbar';
import Footer from '../containers/SaasModern/Footer';

import {
  GlobalStyle,
  ContentWrapper,
} from '../containers/SaasModern/sassModern.style';

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <main>
          <ThemeProvider theme={saasModernTheme}>
            <Fragment>
              <ContentWrapper>
                <ResetCSS />
                <GlobalStyle />
                <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
                  <DrawerProvider>
                    <Navbar />
                  </DrawerProvider>
                </Sticky>
                {children}
                <Footer />
              </ContentWrapper>
            </Fragment>
          </ThemeProvider>
        </main>
      </>
    )}
  />
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
